import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Container } from '@pella/sash-framework';
import Image from '../../../common/image';
import styles from './index.module.scss';
import { isValidArray } from '../../../utilities/validations';

const ThreeGridImage = ({ data, heading, className = '' }) => {
	if (!isValidArray(data)) return null;

	return (
		<Container
			width={1800}
			className={styles.container}
		>
			{heading && <p className={styles.threeGridImage_Heading}>{heading}</p>}

			<div className={`article-grid-container ${className || ''} ${data && data.length ? styles['gridWrap' + data.length] : ''} ${styles.gridContainer}`}>
				{data.map((tips, index) => (
					<div
						key={index}
						className={`${styles.gridItem} ${styles['gridItem' + (index + 1)]}`}
					>
						<Link
							to={tips.url}
							className={styles.gridItem_Link}
						>
							<div className={styles.gridItem_ContentWrapper}>
								{tips.seo?.thumbnail?.url && (
									<Image
										className={`${styles.GridImage} object-cover`}
										data={{ image: tips.seo.thumbnail }}
									/>
								)}

								<div className={styles.threeGrid_ContentWrapper}>
									{tips.top_content.heading && (
										<h3 className={`${data.length <= 2 || index == 0 ? styles.threeGridImage_MainImageTitle : styles.threeGridImage_SubImageTitle} font-semibold uppercase leading-normal tracking-widest`}>
											<span>{tips.top_content.heading}</span>
										</h3>
									)}

									{tips.top_content.summary && (data.length <= 2 || index === 0) && <p className={styles.threeGrid_ImageContent}>{tips.top_content.summary}</p>}
								</div>

								<p className={styles.threeGridImage_Button}>Featured</p>
							</div>
						</Link>
					</div>
				))}
			</div>
		</Container>
	);
};

ThreeGridImage.propTypes = {
	data: PropTypes.array,
	heading: PropTypes.string,
	className: PropTypes.string,
};

export default ThreeGridImage;
